import React, { useEffect, useState } from 'react'
import Navbar from '../Navbar/Navbar'
import Footer from '../Footer/Footer'
import { useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const dataWisata = [
    {
        name: "Wisata Alam Pantai Ropet",
        image_path: "https://res.cloudinary.com/dkltotiq0/image/upload/v1675948107/banraas%2C%20gili-iyang/pantai_ropet_bqi9ll.jpg",
        description: "Berada di wilayah kepulauan Gili Iyang yang terkenal memiliki kadar oksigen terbaik kedua di dunia setelah Laut Mati, Yordania, menjadikan Desa Banra’as sebagai kawasan desa wisata dengan potensi alamnya yang kaya. Pertama ada Pantai Ropet yang berada di ujung timur Desa Banraas. Pantai ini berbeda dengan pantai-pantai pada umumnya. Karena meskipun tidak berpasir, pantai ini memiliki keeksotisan terumbu karang dengan tebing-tebing cantik yang mengapit pesisir pantainya. Saat berkunjung kesana, mataku dimanjakan oleh birunya pemandangan lautan lepas. Bahkan sesekali aku dapat melihat rupa terumbu karang yang ada di bawah air secara tembus pandang. Sedikit lebay, tapi memang sejernih itu yang ku lihat. Tumbuhan nanas laut yang rimbun, pohon kelapa dan taal yang menjulang tinggi, serta tumbuhan-tumbuhan lain yang hidup di sekitaran pantai sangat pas dalam menampakkan keasriannya. Perahu-perahu layar pun tampak berjajar di bibir pantai dengan para nelayan yang sibuk menyandarkan perahu miliknya. Suara ombak diiringi dengan kicauan burung berterbangan yang terdengar begitu lepas akan membuat siapa saja merasa damai. Sewaktu-waktu aku juga mendapati orang-orang yang tengah asyik mengulurkan senar pancingnya, kemudian terlihat kegirangan karena berhasil menarik ikan-ikan yang terjebak oleh umpan. Dan yang paling penting dari semua yang terpenting adalah sebuah foto. Setiap sudut di pantai ini bisa jadi angle yang menarik untuk diabadikan. Spot-spot yang kata orang instagramable juga sengaja di desain di beberapa titik untuk nemenuhi kebutuhan wisatawan dalam berfoto ria. Menarik."
    },
    {
        name: "Tradisi Pembacaan Al-Qur’an Zymat",
        image_path: "https://res.cloudinary.com/dkltotiq0/image/upload/v1675948333/banraas%2C%20gili-iyang/quran_zymat_woxp3w.png",
        description: "Selain potensi alamnya yang kaya, Desa Banra’as juga punya sejarah religi yang dibuktikan dengan ditemukannya Al-Qur’an Azimat. Konan katanya, Al-Qur’an ini ditulis di atas kulit kayu oleh seorang bernama Daeng Masalleh, sembari berjalan menaiki kuda yang ditiungaganginya. Al-Qur’an Azimat rutin dibaca setiap satu tahun sekali dengan sajen-sajen yang wajib ada, yang mana kemudian di letakkan di salah satu tempat bernama Bhujuk Kalompang. <br/> Tidak jauh dari lokasi itu, ada pula gua bernama Gua Petapan yang dahulu digunakan oleh Daeng Massaleh untuk bertapa. Ruang gua ini tidak begitu besar, medannya pun sedikit sulit. Tapi meskipun begitu, pemandangan dinding-dinding diluar Gua dengan kaktus-kaktus yang tumbuh di sekitarannya, serta objek yang langsung menuju lautan lepas semakin menambah daya tarik dari tempat wisata sejarah ini."
    },
    {
        name: "Petilasan dan Goa Petapan",
        image_path: "https://res.cloudinary.com/dkltotiq0/image/upload/v1675948604/banraas%2C%20gili-iyang/photo_2022-12-29_22-03-15_xtqcne.jpg",
        description: "Goa petapan adalah Goa tempat bertapa penulis Al-Qur’an Zymat, yaitu Kiai Siim. Goa tersebut terletak menghadap lautan dan pulau kalimantan. Untuk menuju Goa tersebut memerlukan waktu sekitar 10 menit dari jalan akses utama. Namun akses menuju Goa Petapan tersebut belum dapat dengan mudah ditempuh dengan kendaraan, melainkan harus jalan kaki dengan dipandu oleh rekan-rekan dari Pokdarwis Desa Banraas. Untuk menghormati dan mengingat kiai yang telah membabat pulau Gili Iyang salah satunya adalah Kiai Siim, maka penduduk sekitar selalu mengadakan acara tahunan berupa sukuran yang dilakukan dengan pembacaan AL Qur’an Zymat yang dilakukan oleh Pemuka Agama setelah itu syukuran dilakukan di tempat mengaji Kiai Siim yang letak nya tidak jauh dari Goa Petapan dimana berjarak 100 meter dari Goa Petapan. "
    }
]

function ContentHeader() {

    const { slug } = useParams();
    const [number, setNumber] = useState(0);
    const [content, setContent] = useState({
        name: "",
        image_path: "",
        description: ""
    })
    const navigate = useNavigate();
    const handleGoBack = () => {
        navigate(-1);
    }

    useEffect(() => {
        if (slug === "pantai_ropet") {
            setNumber(0)
        }
        if (slug === "alquran-zymat") {
            setNumber(1)
        }
        if (slug === "goa-petapan") {
            setNumber(2)
        }

        if (number >= 0) {
            setContent({
                name: dataWisata[number].name,
                image_path: dataWisata[number].image_path,
                description: dataWisata[number].description
            })
        }

    }, [slug, number])

    return (
        <>
            <Navbar />
            <div className="flex justify-center">
                <div className="container pb-12 my-24 mt-24 shadow-md bg-white rounded-3xl px-12">
                    <div className="flex justify-start pt-12">
                        <FontAwesomeIcon className="text-3xl w-8 my-auto cursor-pointer" onClick={handleGoBack} icon={faArrowLeft} />
                        <h1 className="my-auto px-12 font-bold text-2xl">{content.name}</h1>
                    </div>
                    <div className="flex">
                        <div className="w-1/2 mr-12">
                            <img src={content.image_path} className="w-full mt-12 rounded-xl" alt="ini adalah gambar" />
                        </div>
                        <div className="w-3/4 mt-12 text-start">
                            <p className='text-base text-justify indent-12 lg:text-lg'>{content.description}</p>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default ContentHeader